// MODULES
import React from "react";
import PropTypes from "prop-types";

// CLASSES
import Session from "@classes/Session";

// COMPONENTS
import DefaultFields from "../../components/DefaultFields/DefaultFields";

// HELPERS
import {createClassName} from "@helpers/utils";
import * as CobHelpers from "../../Cob.helpers";
import fulfillmentCheck from "./Omfattning.fulfillment";
import OptionsList from "../../components/OptionsList/OptionsList";


export default class Omfattning extends React.PureComponent {
	static propTypes = {
		id: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		session: PropTypes.instanceOf(Session).isRequired,
		sectionNumber: PropTypes.number.isRequired,
		number: PropTypes.number.isRequired,
		prevState: PropTypes.object,
		onChange: PropTypes.func.isRequired,
	};

	static companyExclusive = false;
	static privateExclusive = false;
	static fields = _getFields();

	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}

	render() {
		const {props, state} = this;
		const {title, partner} = props;
		const appConfig = partner.appSpecificConfiguration;

		const classes = createClassName("Cob-CustomerInformation", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled,
		});

		let selectedPoaText = "";
		let caseDocument = "";
		for (let i = 0; i < state.fields.type_of_poa.options.length; i++)
		{
			if (state.fields.type_of_poa.options[i].checked)
			{
				for (let j = 0; j < appConfig.poaTypes.length; j++)
				{
					if (appConfig.poaTypes[j].key === state.fields.type_of_poa.options[i].value)
					{
						selectedPoaText = appConfig.poaTypes[j].text;
						caseDocument = appConfig.poaTypes[j].document;
					}
				}

				break;
			}
		}

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<div className="Cob-Fields">
					<h2>{title}</h2>

					<OptionsList
						name="type_of_poa"
						type="radio"
						orientation="vertical"
						options={state.fields.type_of_poa.options}
						onChange={this._onOptionsListChange}
					/>

					{selectedPoaText.length > 0 && (
						<pre style={{
							maxWidth: "600px",
							whiteSpace: "break-spaces",
							width: "100%",
							marginTop: "30px",
							lineHeight: "19px",
							background: "#f7f7f7",
							fontSize: "12px",
							padding: "15px",
							borderRadius: "5px",
							border: "1px solid #ebebeb",
							color: "#444",
							fontFamily: "sans-serif"
						}}>
							{selectedPoaText}
						</pre>
					)}

					<input type={"hidden"} name={"case_document"} value={caseDocument} />
				</div>
			</div>
		);
	}

	// Internal methods

	_onFieldChange = (name, value) => {
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldBlur = (name) => {
		CobHelpers.onViewFieldBlur.call(this, name);
	};

	_onOptionsListChange = ({type, name}, option, index) =>
	{
		const newOptions = [...this.state.fields[name].options].map((o, i) =>
		{
			if (i === index)
			{
				return option;
			}
			else
			{
				return {...o, checked: type === "radio" ? false : o.checked};
			}
		});

		this.setState({
			fields: {
				...this.state.fields,
				[name]: {
					options: newOptions
				}
			}
		}, () => fulfillmentCheck(this.props, this.state));
	};
}

// PRIVATE FUNCTIONS
function _getFields() {
	return [
		"type_of_poa"
	];
}

function _getInitialState() {
	if (this.props.prevState) return {...this.props.prevState};

	const {partner} = this.props;
	const appConfig = partner.appSpecificConfiguration;
	const poaOptions = [];

	for (let i = 0; i < appConfig.poaTypes.length; i++)
	{
		poaOptions.push(
			{
				label: appConfig.poaTypes[i].name,
				value: appConfig.poaTypes[i].key,
				checked: false
			}
		);
	}

	return {
		validFields: {

		},
		fields: {
			type_of_poa: {
				options: poaOptions
			},
		},
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fullmakt/Omfattning.js